import React from "react";
import { Box, Text, Image } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import PermitReviewTableImage from "@root/assets/images/permit-review-table.png";

/**
 * Help content component for Permit Review page
 * Displays instructions and example table for permit review file format
 */
export const PermitReviewHelpContent: React.FC = () => {
  const { t } = useTranslation("common");

  return (
    <>
      {/* Heading */}
      <Text fontSize="18px" fontWeight="600" color="#15161A" mb={4}>
        {t("helpPopover.permitReview.heading")}
      </Text>

      {/* Description */}
      <Text
        fontSize="14px"
        color="#666666"
        mb={4}
        lineHeight="1.6"
        whiteSpace="pre-line"
      >
        {t("helpPopover.permitReview.description")}
      </Text>

      {/* Table Image */}
      <Box mt={4} overflowX="auto">
        <Image
          src={PermitReviewTableImage}
          alt={t("helpPopover.permitReview.imageAlt")}
          maxW="100%"
          width="100%"
          height="auto"
          borderRadius="4px"
        />
      </Box>
    </>
  );
};
